@if(isUserLoggedIn) {
  <loren-nav>
    @if(lorenErrorHandlingService.loading()) {
      <mat-spinner class="loren-details-spinner" />
      } @if(lorenErrorHandlingService.globalError()) {
      @switch(lorenErrorHandlingService.globalError()) { @case(errors.NOT_FOUND)
        {<loren-error-not-found />} @case(errors.FORBIDDEN)
        {<loren-forbidden />} @case(errors.SERVICE_ERROR)
        {<loren-service-unavailable />} @default
        {<loren-general-error />} } } @else {
        <div #contentWrapper (window:resize)="handleContentWrapperHeight()">
          <router-outlet />
        </div>
      }
      <div contextualOutlet class="h-100">
        <router-outlet
          name="details"
          #ro="outlet"
          (activate)="handleDetailsOutletActivated(ro)" />
      </div>
    </loren-nav>
  } @else {
    <router-outlet name="login-router-outlet" />
  }

  <tour-step-template>
    <tour-step-template>
      <ng-template let-step="step">
        <mat-card class="loren-tour-card" (click)="$event.stopPropagation()">
          <mat-card-title class="loren-tour-title">
            {{ $safeNavigationMigration(step?.title) | transloco }}
          </mat-card-title>
          <mat-card-content class="loren-tour-content" [innerHTML]="$safeNavigationMigration(step?.content) | transloco" />
          <mat-card-actions>
            <button
              mat-icon-button
              [disabled]="!tourService.hasPrev(step)"
              (click)="handleTourBack()">
              <mat-icon class="loren-tour-icon">chevron_left</mat-icon>
            </button>
            <button
              mat-icon-button
              [disabled]="!tourService.hasNext(step)"
              (click)="handleTourNext()">
              <mat-icon class="loren-tour-icon">chevron_right</mat-icon>
            </button>
            <button mat-button (click)="handleTourEnd()">
              {{ "tour.end_btn" | transloco }}
            </button>
          </mat-card-actions>
        </mat-card>
      </ng-template>
    </tour-step-template>
  </tour-step-template>

